// extracted by mini-css-extract-plugin
export var footer = "_pq-0";
export var inherit = "_pq-1";
export var input = "_pq-2";
export var modalContent = "_pq-3";
export var quillEditor = "_pq-4";
export var subtitle = "_pq-5";